import { useEffect } from "react";
import { useAppSelector } from "../../../Store";
import { UndefinedOptions } from "..";
import { ValueType } from "../../../Definitions";
import { useDispatch } from "react-redux";
import { selectAllFeedCurveOptions, upsertFeedCurveMilestoneOptions, upsertFeedCurveOptions } from "../../../Store/optionsHandlers/optionsCombinedReducer";
import { gql, useQuery } from "@apollo/client";
import { BasicQueryInfoInput } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedComponentsCall";


const FEED_CURVE_OPTIONS_QUERY = gql`
  query FeedCurveOptions($domain: String!, $input: BasicQueryInfoInput!) {
    feedCurve {
      info(domain: $domain, input: $input) {
        id: feedCurveId
        label: name
        milestones(domain: $domain){
          id: feedCurveMilestoneId
          label: name
          index: milestoneIndex
          milestoneId
        }
      }
    }
  }
`

interface FeedCurveWithMilestoneOptions extends ValueType {
  milestones: (ValueType & {index: number, milestoneId: number})[]
}

interface FeedCurveOptionsResponse {
  feedCurve: {
    info: FeedCurveWithMilestoneOptions[]
  }
}

export const useFeedcurveOptions = (includeUndefinedOption?: UndefinedOptions) => {
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";

  const fetchTime = useAppSelector(({optionsState}) => {if ("lastFetched" in optionsState.feedCurveOptions && typeof optionsState.feedCurveOptions.lastFetched === "number") {return optionsState.feedCurveOptions.lastFetched}})
  const dispatch = useDispatch();
  const reduxOptions = useAppSelector(selectAllFeedCurveOptions);
  const {data: feedCurves, loading } = useQuery<FeedCurveOptionsResponse, {domain: string, input: BasicQueryInfoInput}>(FEED_CURVE_OPTIONS_QUERY, {
   skip: !!reduxOptions.length || fetchTime !== undefined || (fetchTime && (Date.now()-fetchTime > 300000)),
   fetchPolicy: "no-cache",
   variables: {
    domain: farm,
    input: {fetchAmount: 500}
   },
  })

  useEffect(() => {
    if (!loading && feedCurves && !reduxOptions.length) {
      const {feedCurveOptions, milestoneOptions} = feedCurves.feedCurve.info.reduce((agg, feedCurveWithMilestone) => {
        const {milestones, ...feedCurve} = feedCurveWithMilestone;
        agg.feedCurveOptions.push(feedCurve);
        agg.milestoneOptions.push(...milestones.map((milestone) => ({...milestone, feedCurveId: feedCurve.id})))
        return agg
      }, {feedCurveOptions: [], milestoneOptions: []} as {feedCurveOptions: ValueType[], milestoneOptions: (ValueType & {index: number, feedCurveId: number, milestoneId: number} )[]})
      dispatch(upsertFeedCurveOptions(feedCurveOptions));
      dispatch(upsertFeedCurveMilestoneOptions(milestoneOptions));
    }
  },[dispatch, feedCurves, loading, reduxOptions.length])
  
  if (includeUndefinedOption === UndefinedOptions.undefined) {
    return {feedCurveOptions: [{label: "no feed curve", id: null}, ...reduxOptions] as ValueType[]}
  }
  if (includeUndefinedOption === UndefinedOptions.nan) {
    return {feedCurveOptions: [{label: "node feed curve", id: NaN}, ...reduxOptions]}
  }

  return {feedCurveOptions: reduxOptions};
};